import { useEffect } from 'react';

import GridTable from 'components/grid-table/grid-table';
import ProjectsIsAny from './summary-is-any/projects-is-any';
import SummaryHeading from './summary-heading';
import useLazyQuery from 'lib/hooks/use-lazy-query';
import { ProjectDataItem } from 'types';
import { getQueryProjectsById } from 'services/indexer/elastic-queries';
import { columnsProjects } from 'utils/columns-table';
import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';

import config from 'config';
const { DASHBOARD_URL } = config;

import { Row } from 'assets/styles/pages.style';

const SummaryProjectsRow = () => {
  const accountId = useAppSelector(selectAccountId);
  const { data, isLoading, isLoadingMore, hasMore, page, setPage, refetch } =
    useLazyQuery<ProjectDataItem>(getQueryProjectsById);

  useEffect(() => {
    (async function () {
      if (accountId) {
        await refetch(accountId, page);
      }
    })();
  }, [accountId, page]);

  return (
    <>
      <SummaryHeading
        href={DASHBOARD_URL}
        title="My Projects"
        textBtn="Open PO Dashboard"
      />
      <Row mb={6}>
        <GridTable<ProjectDataItem>
          uniqueKey="summary-projects"
          loading={isLoading}
          isLoading={isLoadingMore}
          columns={columnsProjects}
          cols={5}
          componentEmpty={<ProjectsIsAny />}
          hasMore={hasMore}
          setPage={setPage}
          data={data}
        />
      </Row>
    </>
  );
};

export default SummaryProjectsRow;
